module.exports = __webpack_public_path__ + "static/media/email-closed.56d00b2e.jpg";